// Manager Re-Approve — a custom-body popup (see DynamicPopup's config.component
// escape hatch), same shape as manager-approve, but for the loop-back after a
// CFO rejection: renders FinanceApprovalPanel with type
// submissionManagerReapprove (rejection banner + "last rejected rate" hint).
// Admin tags a module's "Re-Approve" action to popupKey "manager-reapprove" —
// gated by a Module Action Rule so it only shows when the submission's
// internal status is "CFO Rejected" (see cmd/wire-submission-cfo-reapprove).
import ManagerReapproveBody from './ManagerReapproveBody.jsx';

export const config = {
  title: 'Re-Approve',
  width: 780,
  className: 'fa-modal manager-approve-modal',
  component: ManagerReapproveBody,
};
